module.exports = __webpack_public_path__ + "static/media/lyn_logo.7e3c4273.svg";